"use client";

import type { ChatSessionElements } from "@whop/embedded-components-vanilla-js/types";

import { createWithFallback } from "../lib/create-with-fallback";
import { useChatSession } from "./session";

export type {
	WithFallbackPropsOptional,
	WithFallbackPropsRequired,
} from "../lib/create-with-fallback";

export const withFallback =
	createWithFallback<ChatSessionElements>(useChatSession);
